import React, { useEffect, useState } from 'react';
import Highlight from '../../../components/Highlight';
import { Container, Center, Space, Section } from '../../../GlobalStyles';
import { BG } from '@etiquette-ui/colors';
import styled from 'styled-components';
import CustomCard from './components/CustomCard';
import { apps } from '../data';
import AllTools from './components/AllCard';

import useI18n from '../../../i18n/useI18n';

const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    grid-gap: 10px;

    margin-top: 30px;
`;

const Combinations = ({ data }) => {
    const [gridElements, setGridElements] = useState([]);
    const { translate, translateObject } = useI18n();
    const highlightTitle = {
        en: 'The best',
        es: 'Las mejores'
    }    
    const title = {
        en: 'combinations',
        es: 'combinaciones'
    }

    const gridMapping = {
        0: [],
        1: [0, 2, 4, 8],
        2: [0, 7, 4],
        3: [0, 5],
        4: [0, 7, 2],
        5: [0, 3],
        6: [0],
        7: [0, 4, 2],
        8: [0]
    };

    useEffect(() => {
        setGridElements(gridMapping[data.currentPage] || []);
    }, [data.currentPage]);

    const cards = [];

    gridElements.map((index) => (apps.map((item) => ((item.img === index) && cards.push(item)))));

    return (
        <Section color={BG}>
            <Container>
                <Space />
                <Center>
                    <h2 data-sal="slide-up" data-sal-easing="ease-in-circ">
                        <Highlight text={translateObject(highlightTitle)} /> {translateObject(title)}
                    </h2>
                    <p data-sal="slide-up" data-sal-easing="ease-in-circ" data-sal-delay='200'>
                        {translateObject({
                            en: `Undoubtedly the best thing is to have all the tools working together,
                            however there are some tools that are directly more related than others,
                            learn how it works.`,
                            es: `Sin duda lo mejor es tener todas las herramientas trabajando juntas,
                            sin embargo, hay algunas herramientas que están directamente más relacionadas que otras,
                            aprende cómo funcionan.`
                        })}
                    </p>
                </Center>

                {data.currentPage === 0 ? <AllTools />
                    :
                    <Row>
                        {cards.map((item, i) =>
                            <CustomCard
                                icon={item.img}
                                title={translate(item.app)}
                                description={translateObject(item.description)}
                                data-sal="fade" data-sal-easing="ease-in-circ" data-sal-duration='1500'
                            />
                        )}
                    </Row>
                }
                <Space size='90' />
            </Container>
        </Section>
    )
}

export default Combinations;